import { DataType } from '../../../../models/Enums';
import ValidationRuleModel, { IValidationRuleProvider } from '../../../../models/ValidationRuleModel';

/** Question Bank Survey validation rules */
const ValidationRules: IValidationRuleProvider = {
    hasSelfAssessmentQuestions: new ValidationRuleModel(DataType.Boolean, true),
}

export default ValidationRules;